/**
 * @name SwitchComponent
 * @desc A component that renders the toggle switch
 * @author Shalini Jha
 */
import React from 'react';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { SwitchStyles } from './overwriteStyles';
import styles from './Switch.module.css';
const { withStyles } = MaterialUiCore;
const { Typography } = MaterialUiCore;
const { Grid } = MaterialUiCore;
const { Switch } = MaterialUiCore;

const SwitchComponent = ({ value, handleChange, ...rest }) => (
    <Typography component="div">
        <Grid component="label" container alignItems="center" spacing={1}>
            <Grid className={styles.switch_offLabel} item>
                OFF
            </Grid>
            <Grid item>
                <Switch checked={value} onChange={handleChange} name="checkedC" {...rest} />
            </Grid>
            <Grid className={styles.switch_onLabel} item>
                ON
            </Grid>
        </Grid>
    </Typography>
);

SwitchComponent.propTypes = {
    value: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
};
export default withStyles(SwitchStyles)(SwitchComponent);
export { SwitchComponent };
